export default __webpack_public_path__ + "static/media/EM0330.34I-22003_-25386_0.0564fca0.jpg";